import { GoalDTO, GoalType } from './api/useGoalsQuery';
import { HomePurchaseGoalData } from './goals/HomePurchase/HomePurchase.meta';
import { LargePurchaseData } from './goals/LargePurchase/LargePurchase.meta';

export const GOAL_ICON_MAP = {
  [GoalType.Retirement]: 'far fa-island-tropical',
  [GoalType.Education]: 'far fa-graduation-cap',
  [GoalType.EmergencyFund]: 'far fa-life-ring',
  [GoalType.HealthCare]: 'far fa-hands-heart',
  [GoalType.Insurance]: 'far fa-umbrella',
  [GoalType.DebtManagement]: 'far fa-credit-card',
  [GoalType.HomePurchase]: 'far fa-home',
  [GoalType.EstatePlanning]: 'far fa-clipboard-list-check',
  [GoalType.LargePurchase]: 'far fa-dollar-sign',
  [GoalType.Decumulation]: 'far fa-comments-dollar',
  [GoalType.CharitableGiving]: 'far fa-envelope-open-dollar',
};

export const NEW_LARGE_PURCHASE_GOAL: GoalDTO = {
  id: null,
  type: GoalType.LargePurchase,
  goalData: {
    cost: null,
    desiredPurchaseYear: null,
    inflation: null,
    purchaseAtRetirement: false,
    repeatEveryNYears: 1,
    repeatForNYears: 1,
  } as LargePurchaseData,
  isSelected: false,
  isDisabled: false,
  name: '',
  assetBucketingIndices: [],
};

export const NEW_HOME_PURCHASE_GOAL: GoalDTO = {
  id: null,
  type: GoalType.HomePurchase,
  goalData: {
    downPayment: null,
    purchaseAtRetirement: null,
    desiredPurchaseYear: null,
    marketValue: null,
    mortgageType: null,
    interestRate: null,
    propertyTax: null,
    pmi: null,
    homeInsurancePerYear: null,
    monthlyHoa: null,
    assetGrowth: null,
  } as HomePurchaseGoalData,
  isSelected: false,
  isDisabled: false,
  name: '',
  assetBucketingIndices: [],
};

export const BUY_CAR_GOAL_NAME = 'Buy a car';
export const AT_RETIREMENT = 'At Retirement';
export const ALREADY_ENROLLED = 'Already Enrolled';
export const ALREADY_RETIRED = 'Already Retired';
